$(document).on('turbo:load', function() {
  if (typeof(ga) === "function") {
    ga("set", "location", location.pathname);
    ga("send", "pageview");
  }
})
